import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from './AccessDeniedCard';
import { usePermissions } from '../hooks/usePermissions';

export default function EInvoiceAccessLayout({ title, permission, permissions, requireAll = false }) {
  const { loading, hasEInvoicePermission } = usePermissions();

  if (loading) {
    return null;
  }

  let isAllowed;
  if (permissions) {
    isAllowed = requireAll
      ? permissions.every((code) => hasEInvoicePermission(code))
      : permissions.some((code) => hasEInvoicePermission(code));
  } else {
    isAllowed = hasEInvoicePermission(permission);
  }

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
